import { render } from "./SiteHeader.vue?vue&type=template&id=40a50d12&bindings={\"doLogout\":\"options\"}"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"
script.render = render

export default script